import React, { Component } from "react";
import AntdSpin, {SpinProps} from "antd/lib/spin";
import "antd/lib/spin/style";

const { setDefaultIndicator } = AntdSpin;
export default class Spin extends Component<SpinProps> {
  static setDefaultIndicator = setDefaultIndicator;
  render() {
    return <AntdSpin {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/spin/index.tsx